import { Autocomplete, TextField, useTheme } from '@mui/material'
import { useTranslation } from 'react-i18next'
import { useFormikContext } from 'formik'

import { ETranslationNs, IScanCreateForm } from 'src/types'

import useStyles from 'src/components/text-input/styles'
import { useStyles as useStyles2 } from '../styles'
import { HelperWrapper } from 'src/components/helper-wrapper'

type InputType = keyof IScanCreateForm

interface IProps {
  inputName: Extract<
    InputType,
    'batch_id' | 'sender_reference_id' | 'receiver_reference_id' | 'invoice_reference'
  >
  inputUpperLabel?: string
  inputPlaceholder?: string
  data?: string[]
  isLoading?: boolean
}

export const AutocompleteInput = ({
  inputName,
  inputUpperLabel,
  inputPlaceholder,
  data,
  isLoading,
}: IProps) => {
  const [t] = useTranslation([ETranslationNs.Common, ETranslationNs.Form])
  const { values, setFieldValue, errors, handleChange } = useFormikContext<IScanCreateForm>()
  const theme = useTheme()
  const classes = useStyles({})
  const classes2 = useStyles2()

  const handleInputChange = (event: any, value: null | string) => {
    setFieldValue(inputName, value || '')
  }

  return (
    <Autocomplete
      autoHighlight
      freeSolo
      defaultValue={values[inputName]}
      options={data || []}
      ListboxProps={{ className: classes2.inputList }}
      value={values[inputName]}
      isOptionEqualToValue={(option, value) => option === value}
      fullWidth
      onChange={handleInputChange}
      loading={isLoading}
      loadingText={t('loading-text-notification.v')}
      renderInput={(props) => (
        <TextField
          {...props}
          autoComplete="off"
          fullWidth
          variant="standard"
          className={classes.container}
          style={{ height: '100%', width: '100%' }}
          InputProps={{
            ...props.InputProps,
            disableUnderline: true,
          }}
          inputProps={{
            ...props.inputProps,
            className: classes.input,
          }}
          InputLabelProps={{
            className: classes.label,
            style: {
              color: theme.palette.custom.grey2,
            },
          }}
          name={inputName}
          size="small"
          label={inputUpperLabel}
          focused
          onChange={handleChange}
          FormHelperTextProps={{
            error: !!errors[inputName],
          }}
          helperText={errors[inputName] && <HelperWrapper t={errors[inputName] as string} />}
          placeholder={`${t('text-input-placeholder-prepend.v', {
            ns: ETranslationNs.Form,
          })} ${inputPlaceholder}`}
          type="text"
        />
      )}
    />
  )
}
